/* Wraps loose page-content images in an overflow-hidden container
   so the hover zoom stays inside the image's footprint. */
(function () {
  function wrapContentImages() {
    var imgs = document.querySelectorAll('main .rte img');
    imgs.forEach(function (img) {
      if (img.closest('.img-zoom') || img.closest('.fl-item') || img.closest('.gallery-tile') || img.closest('.product-card__media')) return;
      var wrap = document.createElement(img.closest('a') ? 'span' : 'div');
      wrap.className = 'img-zoom';
      img.parentNode.insertBefore(wrap, img);
      wrap.appendChild(img);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapContentImages);
  } else {
    wrapContentImages();
  }
})();
